export const isSelectedVolumeContractAvailable = (volumeContracts, selectedContract) => {
    if (!selectedContract) return true;

    return (volumeContracts ?? []).some(
        (contract) => Number(contract.id) === Number(selectedContract.contrato),
    );
};
